export const type = 'form.tabs';
